module.exports = __webpack_public_path__ + "static/media/14_vedenalainen-elama.8c2f73ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/agendaIcons/14_vedenalainen-elama.svg
// module id = ./src/images/agendaIcons/14_vedenalainen-elama.svg
// module chunks = 1